// @flow
import React from 'react';

type PanelProps = {
    children: any
}

type PanelState = { }

export default class Panel extends React.Component<PanelProps, PanelState> {

    constructor (props: PanelProps){
        super(props);
    }

    render = () =>  <div className="panel">
        { this.props.children }
    </div>
}